import { Schema } from 'effect';

const possiblePhases = [
  'NA',
  'EARLY_PHASE_1',
  'PHASE1',
  'PHASE2',
  'PHASE3',
  'PHASE4',
] as const;

type PossiblePhases = typeof possiblePhases;

export const phaseMap: Record<PossiblePhases[number], string> = {
  NA: 'Not Applicable',
  EARLY_PHASE_1: 'Early Phase 1',
  PHASE1: 'Phase 1',
  PHASE2: 'Phase 2',
  PHASE3: 'Phase 3',
  PHASE4: 'Phase 4',
};

const phasesSchema = Schema.Literal(...possiblePhases);

export const apiResponseSchemaForTrialExperience = Schema.Struct({
  studies: Schema.Array(
    Schema.Struct({
      protocolSection: Schema.partial(
        Schema.Struct({
          conditionsModule: Schema.partial(
            Schema.Struct({
              conditions: Schema.Array(Schema.String),
            }),
          ),
          designModule: Schema.partial(
            Schema.Struct({
              phases: Schema.Array(phasesSchema),
            }),
          ),
          identificationModule: Schema.partial(
            Schema.Struct({
              nctId: Schema.String,
              officialTitle: Schema.String,
            }),
          ),
          sponsorCollaboratorsModule: Schema.partial(
            Schema.Struct({
              leadSponsor: Schema.partial(
                Schema.Struct({
                  name: Schema.String,
                }),
              ),
            }),
          ),
        }),
      ),
    }),
  ),
});

export const apiResponseSchemaForExternalTrialCreation = Schema.Struct({
  studies: Schema.Array(
    Schema.Struct({
      protocolSection: Schema.partial(
        Schema.Struct({
          sponsorCollaboratorsModule: Schema.partial(
            Schema.Struct({
              leadSponsor: Schema.partial(
                Schema.Struct({
                  name: Schema.String,
                }),
              ),
            }),
          ),
          identificationModule: Schema.partial(
            Schema.Struct({
              nctId: Schema.String,
              officialTitle: Schema.String,
            }),
          ),
          eligibilityModule: Schema.partial(
            Schema.Struct({
              eligibilityCriteria: Schema.String,
              sex: Schema.String,
              minimumAge: Schema.String,
            }),
          ),
        }),
      ),
    }),
  ),
});
